__turbopack_context__.v({
  "header": "Header-module-scss-module__jfOynq__header",
  "header__actions": "Header-module-scss-module__jfOynq__header__actions",
  "header__active-region": "Header-module-scss-module__jfOynq__header__active-region",
  "header__hamburger": "Header-module-scss-module__jfOynq__header__hamburger",
  "header__logo": "Header-module-scss-module__jfOynq__header__logo",
  "header__logo-link": "Header-module-scss-module__jfOynq__header__logo-link",
  "header__mobile-actions": "Header-module-scss-module__jfOynq__header__mobile-actions",
  "header__primary": "Header-module-scss-module__jfOynq__header__primary",
  "header__secondary": "Header-module-scss-module__jfOynq__header__secondary",
  "header__secondary-link": "Header-module-scss-module__jfOynq__header__secondary-link",
  "header__secondary-link--large": "Header-module-scss-module__jfOynq__header__secondary-link--large",
  "header__secondary-list": "Header-module-scss-module__jfOynq__header__secondary-list",
});
